let epoch = 0;
let suppressUnauthorizedUntil = 0;

/** Drop in-flight auth reloads that would sign the shopper back in after a contact change. */
export const bumpAuthEpoch = () => {
  epoch += 1;
  suppressUnauthorizedUntil = Date.now() + 15000;
  return epoch;
};

export const currentAuthEpoch = () => epoch;

export const shouldIgnoreAuthCallback = (capturedEpoch) => capturedEpoch !== epoch;

export const isContactSignOutActive = () => Date.now() < suppressUnauthorizedUntil;
